
<div class="iframe-container">

    <iframe
        src="https://escarcega.tecnm.mx/convocatorias/"
        frameborder="0">
    </iframe>

</div>